import React, { Component } from 'react';
import { ClipLoader } from 'react-spinners'; // Import desired spinner

export const LoadingPage = () => {
  return (
    <div className="sweet-loading" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "45vh", backgroundColor: "rgba(255, 255, 255, 0.69)" }}>
      <ClipLoader 
        color="#36d7b7" 
        loading={true} 
        size={50} 
      />
    </div>
  );
};
